import React from 'react';
import Logo from './Logo';
import { FiAlertTriangle } from 'react-icons/fi';

const AppReloader = () => {
  return (
    <div style={{ top: '50%', left: '50%', position: 'absolute', marginTop: '-70px', marginLeft: '-100px' }}>
      <Logo width={200} />
      <div className="mt-5 text-center">
        <FiAlertTriangle size={44} />
        <p>Ocorreu algum problema de conexão.</p>
        <br />
        <a href="/" className="btn btn-link">
          Recarregue a página
        </a>
      </div>
    </div>
  );
};

export default AppReloader;
